import React, { Component, Fragment } from 'react';

import URC from 'ui-react-common';

const { Type, Link } = URC.ui.components;
const { config } = URC;

class CommunicationConsent extends Component {
    render() {
        const baseUrl = config.webUIUrl;

        return (
            <Fragment>
                <Type.BodyFour>
                    <strong>Communication Consent:</strong>
                </Type.BodyFour>
                <Type.BodyFour>
          By submitting your contact information you agree to our{' '}
                    <Link
                        href={`${baseUrl}terms-of-service`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
          Terms of Use
                    </Link>
          . You also expressly consent to having us, our{' '}
                    <Link
                        href='https://www.rocketcompanies.com/our-companies/'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
          affiliates
                    </Link>
          , and potentially our partners contact you about your inquiry by text
          message or phone (including automatic telephone dialing system or an
          artificial or pre-recorded voice) to the residential or cellular
          telephone number you have provided, even if that telephone number is
          on a corporate, state, or national Do Not Call Registry. You do not
          have to agree to receive such calls or messages as a condition of
          getting any services from Rocket Loans or its affiliates. You
          acknowledge that you provided us your cellular number and you provided
          your cellular number during a transaction that if consummated will
          result in you owing a debt to Cross River Bank, a New Jersey-state
          chartered bank, Member FDIC. You also consent to us contacting you
          through the email address you have provided us. If you want to opt out of
          receiving marketing information by email, telephone, text message,
          and/or mail, please email{' '}
                    <Link
                        href={`mailto:${
                            config.global.company.email.support
                        }?Subject=Talk%20to%20Us`}
                        target="_top"
                    >
                        {config.global.company.email.support}
                    </Link>{' '}
          with the subject &#34;Opt Out&#34; or call{' '}
                    <Link
                        href={`tel://${config.global.company.phone.dash}`}
                    >
                        {config.global.company.phone.long}
                    </Link>
          . For more information about how we process your personal information, see the Rocket Family of Companies{' '}
                    <Link
                        href='https://rocketaccount.com/#/privacy-policy/'
                        target="_blank"
                        rel="noopener noreferrer"
                    >
          Privacy Policy
                    </Link>
          .
                </Type.BodyFour>
                <br />
            </Fragment>
        );
    }
}

export default CommunicationConsent;
